import { useId } from 'react'
import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps, M_CARD } from './mobileMotion'

export default function Slide3M() {
  const gid = useId().replace(/:/g, '')
  const { t } = useLanguage()
  const s = t.slides.slide3

  return (
    <MobileSlideShell>
      <motion.p
        {...fadeScaleProps(0)}
        className="text-[13px] font-bold uppercase tracking-[0.2em] text-[#1B2A6B]/50"
      >
        {s.eyebrow}
      </motion.p>

      <motion.h2
        {...fadeScaleProps(0.06)}
        className="text-[26px] font-semibold leading-tight tracking-tight text-[#1B2A6B]"
      >
        {s.headline}
      </motion.h2>

      <motion.div
        {...fadeScaleProps(0.1)}
        className={`${M_CARD} flex flex-wrap items-end justify-center gap-6 py-6`}
      >
        <div className="flex flex-col items-center gap-2">
          <svg viewBox="0 0 88 88" fill="none" className="h-[72px] w-[72px] shrink-0">
            <circle cx="44" cy="44" r="34" stroke="rgba(27,42,107,0.22)" strokeWidth="2.5"
              fill="rgba(27,42,107,0.05)" strokeDasharray="6 4" />
            <circle cx="44" cy="44" r="18" fill="rgba(27,42,107,0.07)" />
            <circle cx="44" cy="18" r="7" fill="rgba(27,42,107,0.14)" />
            <circle cx="66" cy="56" r="6" fill="rgba(27,42,107,0.14)" />
            <circle cx="22" cy="57" r="6" fill="rgba(27,42,107,0.14)" />
            <text x="44" y="48" fontSize="9" fontWeight="700" fill="rgba(27,42,107,0.5)"
              textAnchor="middle" fontFamily="system-ui, sans-serif">C₈H₁₈</text>
          </svg>
          <span className="text-[14px] font-semibold uppercase tracking-wider text-[#1B2A6B]/40">
            {s.fuelLabel}
          </span>
        </div>

        <div className="flex flex-col items-center gap-2 pb-8">
          <span className="text-[18px] font-bold text-[#22A756]">H₂</span>
          <svg viewBox="0 0 72 18" fill="none" className="h-4 w-[72px]">
            <defs>
              <linearGradient id={`m3-ag-${gid}`} x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="#22A756" stopOpacity="0.3" />
                <stop offset="100%" stopColor="#22A756" />
              </linearGradient>
            </defs>
            <line x1="2" y1="9" x2="58" y2="9" stroke={`url(#m3-ag-${gid})`} strokeWidth="2.5" strokeLinecap="round" />
            <polyline points="50,3 62,9 50,15" fill="none" stroke="#22A756" strokeWidth="2.5"
              strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className="text-[14px] font-medium text-[#22A756]/70">{s.catalystLabel}</span>
        </div>

        <div className="flex flex-col items-center gap-2">
          <svg viewBox="0 0 88 88" fill="none" className="h-[72px] w-[72px] shrink-0">
            <circle cx="44" cy="44" r="34" fill="rgba(34,167,86,0.08)" />
            <circle cx="44" cy="44" r="22" fill="rgba(34,167,86,0.15)" />
            <circle cx="44" cy="44" r="13" fill="rgba(34,167,86,0.28)" />
            {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => {
              const rad = (a * Math.PI) / 180
              return (
                <line
                  key={a}
                  x1={44 + 16 * Math.cos(rad)}
                  y1={44 + 16 * Math.sin(rad)}
                  x2={44 + 30 * Math.cos(rad)}
                  y2={44 + 30 * Math.sin(rad)}
                  stroke="#22A756"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                />
              )
            })}
            <text x="44" y="48" fontSize="9" fontWeight="800" fill="#22A756"
              textAnchor="middle" fontFamily="system-ui, sans-serif">H₂O</text>
          </svg>
          <span className="text-[14px] font-semibold uppercase tracking-wider text-[#22A756]/70">
            {s.cleanLabel}
          </span>
        </div>
      </motion.div>

      <motion.p
        {...fadeScaleProps(0.16)}
        className="text-[16px] leading-relaxed text-[#1B2A6B]/65"
      >
        {s.body}{' '}
        <strong className="font-semibold text-[#1B2A6B]">8–10×</strong>{' '}
        {s.body2}
      </motion.p>
    </MobileSlideShell>
  )
}
